import { css } from '@emotion/css';

export const switchStyles = css`
  /* Overrides */
  .MuiSwitch-track {
    opacity: 1 !important;
    outline: 0.16rem solid transparent;
  }

  /* Hover Styles */
  :hover .MuiSwitch-switchBase:not(.Mui-disabled) {
    background-color: transparent;

    /* Normal State */
    & + .MuiSwitch-track {
      background-color: var(--interactive-secondary-active);
    }
    /* Checked State */
    &.Mui-checked + .MuiSwitch-track {
      background-color: var(--interactive-primary-hover);
    }
  }

  /* Focus State */
  .Mui-focusVisible + .MuiSwitch-track {
    outline-offset: 0.32rem;
    box-shadow: 0 0 0 0.16rem var(--interactive-white), 0 0 0 0.32rem var(--focus-primary);
  }

  .MuiSwitch-switchBase {
    outline: 0.16rem solid transparent;

    /* Checked State */
    &.Mui-checked {
      transform: translateX(var(--tw-translate-x));

      & + .MuiSwitch-track {
        background-color: var(--interactive-primary);
      }
    }

    /* Disabled State */
    &.Mui-disabled + .MuiSwitch-track {
      opacity: 0.5 !important;
    }
  }
`;
